import "bootstrap/dist/css/bootstrap.min.css";
import React, { createContext, Suspense, useContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Login from "./pages/Login";
import SendOtp from "./pages/SendOtp";
import VerifyOtp from "./pages/VerifyOtp";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Overview from "./pages/Overview";
import Vendors from "./pages/Vendors";
import AddVendor from "./pages/AddVendor";
import Colleges from "./pages/Colleges";
import CollegeList from "./pages/CollegeList";
import AddCollege from "./pages/AddCollege";

//Vendors

import VendorLogin from "./pages/vendor/auth/Login";
import VendorCollegeList from "./pages/vendor/colleges/CollegeList";
import VendorTeacherList from "./pages/vendor/teachers/TeacherList";
import VendorColleges from "./pages/vendor/colleges/Colleges";
import VendorTeachers from "./pages/vendor/teachers/Teachers";
import VendorAddTeacher from "./pages/vendor/teachers/AddTeacher";
import VendorAddCollege from "./pages/vendor/colleges/AddCollege";
import VendorOverview from "./pages/vendor/Overview";
import Approvals from "./pages/vendor/approvals/Approvals";
import ApprovalList from "./pages/vendor/approvals/ApprovalList";
import PhoneModal from "./pages/vendor/auth/AddMobile";
import OTPVerificationModal from "./pages/vendor/auth/OTPVerification";
import AddPrerecordLesson from "./pages/courses/AddPrerecordLesson";
import ForgotPasswordModal from "./pages/vendor/auth/ForgotPassword";
import ResetPasswordModal from "./pages/vendor/auth/ResetPassword";
import { AuthProvider, useAuth } from "./context/AuthContext";
import {
  AdminRoute,
  CollegeRoute,
  StudentRoute,
  TeacherRoute,
  VendorRoute,
} from "./components/protected-routes/ProtectedRoutes";
import { QueryClient, QueryClientProvider, useMutation } from "react-query";
import { AlertProvider } from "./context/AlertContext";
import { IDsProvider } from "./context/IDsContext";
// import Inquiry from "./pages/Inquiry";
import Setting from "./pages/Setting";

//Admin

const Teachers = React.lazy(() => import("./pages/teachers/Teachers"));
const TeacherList = React.lazy(() => import("./pages/teachers/TeacherList"));
const AddTeacher = React.lazy(() => import("./pages/teachers/AddTeacher"));
const Students = React.lazy(() => import("./pages/students/Students"));
const StudentList = React.lazy(() => import("./pages/students/StudentList"));
const AddStudent = React.lazy(() => import("./pages/students/AddStudent"));

const Courses = React.lazy(() => import("./pages/courses/Courses"));
const AddCourse = React.lazy(() => import("./pages/courses/AddCourse"));
const AddModule = React.lazy(() =>
  import("./pages/courses/add-module/AddModule")
);
const LiveSession = React.lazy(() => import("./pages/courses/LiveSession"));
const UpcomingSession = React.lazy(() =>
  import("./pages/courses/UpcomingSession")
);
const AddLeason = React.lazy(() => import("./pages/courses/AddLeason"));
const AddContent = React.lazy(() => import("./pages/courses/AddContent"));
const AddPrerecord = React.lazy(() => import("./pages/courses/AddPrerecord"));

const Analytics = React.lazy(() => import("./pages/analytics/Analytics"));

//Vendors

const VendorCourses = React.lazy(() =>
  import("./pages/vendor/courses/Courses")
);
const VendorAddCourse = React.lazy(() =>
  import("./pages/vendor/courses/AddCourse")
);
const VendorAddLeason = React.lazy(() =>
  import("./pages/vendor/courses/AddLeason")
);
const VendorAddModule = React.lazy(() =>
  import("./pages/vendor/courses/add-module/AddModule")
);
const VendorAddPrerecord = React.lazy(() =>
  import("./pages/vendor/courses/AddPrerecord")
);
const VendorAddPrerecordLesson = React.lazy(() =>
  import("./pages/vendor/courses/AddPrerecordLesson")
);
const VendorAddContent = React.lazy(() =>
  import("./pages/vendor/courses/AddContent")
);
const VendorLiveSession = React.lazy(() =>
  import("./pages/vendor/courses/LiveSession")
);
const VendorUpcomingSession = React.lazy(() =>
  import("./pages/vendor/courses/UpcomingSession")
);
const VendorStudents = React.lazy(() =>
  import("./pages/vendor/students/Students")
);
const VendorCollege = React.lazy(() =>
  import("./pages/vendor/quizes/Colleges")
);
const VendorTeachersList = React.lazy(() =>
  import("./pages/vendor/quizes/TeacherList")
);
const VendorViewQuizzes = React.lazy(() =>
  import("./pages/vendor/quizes/ViewQuzzies")
);
const VendorCreateDetails = React.lazy(() =>
  import("./pages/vendor/quizes/CreateDetails")
);
const VendorShowQuestion = React.lazy(() =>
  import("./pages/vendor/quizes/ShowQuestion")
);
const VendorEvaluateDetails = React.lazy(() =>
  import("./pages/vendor/quizes/EvaluateDetails")
);
const VendorStudentList = React.lazy(() =>
  import("./pages/vendor/students/StudentList")
);
const VendorAddStudent = React.lazy(() =>
  import("./pages/vendor/students/AddStudent")
);
const VendorAnalytics = React.lazy(() =>
  import("./pages/vendor/analytics/Analytics")
);

//Teachers

const TeacherLogin = React.lazy(() => import("./pages/teacher/auth/Login"));
const AddModal = React.lazy(() => import("./pages/teacher/auth/AddMobile"));
const OtpVerification = React.lazy(() =>
  import("./pages/teacher/auth/OtpVerification")
);
const TeacherForgotPasswordModal = React.lazy(() =>
  import("./pages/teacher/auth/ForgotPassword")
);
const TeacherResetPasswordModal = React.lazy(() =>
  import("./pages/teacher/auth/ResetPassword")
);
const TeacherOverview = React.lazy(() => import("./pages/teacher/Overview"));
const TeacherStudents = React.lazy(() =>
  import("./pages/teacher/students/Students")
);
const TeacherStudentList = React.lazy(() =>
  import("./pages/teacher/students/StudentList")
);
const TeacherAddStudent = React.lazy(() =>
  import("./pages/teacher/students/AddStudent")
);
const TeacherAssignStudent = React.lazy(() =>
  import("./pages/teacher/students/AssignStudent")
);
const TeacherAnalytics = React.lazy(() =>
  import("./pages/teacher/analytics/Analytics")
);
const TeacherCourses = React.lazy(() =>
  import("./pages/teacher/courses/Courses")
);
const TeacherAddCourses = React.lazy(() =>
  import("./pages/teacher/courses/AddCourse")
);
const TeacherAddContent = React.lazy(() =>
  import("./pages/teacher/courses/AddContent")
);
const TeacherAddLesson = React.lazy(() =>
  import("./pages/teacher/courses/AddLesson")
);
const TeacherAddPrerecord = React.lazy(() =>
  import("./pages/teacher/courses/AddPrerecord")
);
const TeacherLiveSession = React.lazy(() =>
  import("./pages/teacher/courses/LiveSession")
);
const TeacherAddModule = React.lazy(() =>
  import("./pages/teacher/courses/AddModule")
);
const TeacherUpcomingSession = React.lazy(() =>
  import("./pages/teacher/courses/UpcomingSession")
);
const TeacherQuizes = React.lazy(() => import("./pages/teacher/quizes/Quizes"));
const TeacherAddQuiz = React.lazy(() =>
  import("./pages/teacher/quizes/AddQuiz")
);
const TeacherAddQuestion = React.lazy(() =>
  import("./pages/teacher/quizes/AddQuestion")
);
const TeacherStartEvaluation = React.lazy(() =>
  import("./pages/teacher/quizes/evaluation/StartEvaluation")
);
const TeacherViewDetails = React.lazy(() =>
  import("./pages/teacher/quizes/ViewDetails")
);

//Colleges

const CollegeLogin = React.lazy(() => import("./pages/college/auth/Login"));
const AddMobile = React.lazy(() => import("./pages/college/auth/AddMobile"));
const OtpVerifications = React.lazy(() =>
  import("./pages/college/auth/OtpVerification")
);
const CollegeForgotPasswordModal = React.lazy(() =>
  import("./pages/college/auth/ForgotPassword")
);
const CollegeResetPasswordModal = React.lazy(() =>
  import("./pages/college/auth/ResetPassword")
);
const CollegeOverview = React.lazy(() => import("./pages/college/Overview"));
const CollegeCourses = React.lazy(() =>
  import("./pages/college/courses/Courses")
);
const CollegeLiveSession = React.lazy(() =>
  import("./pages/college/courses/LiveSession")
);
const CollegeUpcomingSession = React.lazy(() =>
  import("./pages/college/courses/UpcomingSession")
);
const CollegeStudents = React.lazy(() =>
  import("./pages/college/students/Students")
);
const CollegeStudentList = React.lazy(() =>
  import("./pages/college/students/StudentList")
);
const CollegeAddStudent = React.lazy(() =>
  import("./pages/college/students/AddStudent")
);
const CollegeTeachers = React.lazy(() =>
  import("./pages/college/teachers/Teachers")
);
const CollegeTeacherList = React.lazy(() =>
  import("./pages/college/teachers/TeacherList")
);
const CollegeAddTeacher = React.lazy(() =>
  import("./pages/college/teachers/AddTeacher")
);
const CollegeAssignTeacher = React.lazy(() =>
  import("./pages/college/teachers/AssignTeacher")
);
const CollegeAnalytics = React.lazy(() =>
  import("./pages/college/analytics/Analytics")
);
const CollegeTeachersList = React.lazy(() =>
  import("./pages/college/quizes/TeacherList")
);
const CollegeViewQuizzes = React.lazy(() =>
  import("./pages/college/quizes/ViewQuizes")
);
const CollegeCreateDetails = React.lazy(() =>
  import("./pages/college/quizes/CreateDetail")
);
const CollegeShowQuestion = React.lazy(() =>
  import("./pages/college/quizes/ShowQuestions")
);
const CollegeEvaluateDetails = React.lazy(() =>
  import("./pages/college/quizes/EvaluateDetail")
);

//Students

const StudentLogin = React.lazy(() => import("./pages/student/auth/Login"));
const GetOtp = React.lazy(() => import("./pages/student/auth/GetOtp"));
const VerificationsOTP = React.lazy(() =>
  import("./pages/student/auth/VerificationsOTP")
);
const StudentForgotPasswordModal = React.lazy(() =>
  import("./pages/student/auth/ForgotPassword")
);
const StudentResetPasswordModal = React.lazy(() =>
  import("./pages/student/auth/ResetPassword")
);
const StudentOverview = React.lazy(() => import("./pages/student/Overview"));
const StudentCourses = React.lazy(() =>
  import("./pages/student/courses/Courses")
);
const StudentCourseDetails = React.lazy(() =>
  import("./pages/student/courses/CourseDetails")
);
const StudentLessonCompleted = React.lazy(() =>
  import("./pages/student/courses/LessonCompleted")
);
const StudentLiveSession = React.lazy(() =>
  import("./pages/student/live-sessions/LiveSession")
);
const StudentUpcomingSession = React.lazy(() =>
  import("./pages/student/live-sessions/UpcomingSession")
);
const StudentQuizes = React.lazy(() => import("./pages/student/quizes/Quizes"));
const StudentStartQuiz = React.lazy(() =>
  import("./pages/student/quizes/StartQuiz")
);
const StudentResultPending = React.lazy(() =>
  import("./pages/student/quizes/ResultPending")
);
const StudentViewResult = React.lazy(() =>
  import("./pages/student/quizes/ViewResult")
);
const StudentViewCertificate = React.lazy(() =>
  import("./pages/student/quizes/ViewCertificate")
);

const LoadingFallback = () => <div className="text-center p-5">Loading...</div>;

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      retry: 1, // Only retry failed requests once
    },
  },
});

const VisibilityHandler = () => {
  const { endSession, startTimer } = useAuth(); // Get endSession from AuthContext

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("User switched tab or minimized the browser");
        endSession();
      } else {
        console.log("User came back to the tab");
        startTimer();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [endSession]);

  return null; // This component doesn't render anything
};

const AppRoutes = () => {
  return (
    <>
      <VisibilityHandler />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Public routes - accessible without authentication */}
          <Route path="/login" element={<Login />} />
          <Route path="/add-mobile" element={<SendOtp />} />
          <Route path="/otp-verification" element={<VerifyOtp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Admin routes */}
          <Route element={<AdminRoute />}>
            <Route path="/" element={<Overview />} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/add-vendor" element={<AddVendor />} />
            <Route path="/colleges" element={<Colleges />} />
            <Route path="/college-list" element={<CollegeList />} />
            <Route path="/add-college" element={<AddCollege />} />
            <Route path="/teachers" element={<Teachers />} />
            <Route path="/teacher-list" element={<TeacherList />} />
            <Route path="/add-teacher" element={<AddTeacher />} />
            <Route path="/students" element={<Students />} />
            <Route path="/student-list" element={<StudentList />} />
            <Route path="/add-student" element={<AddStudent />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/add-course" element={<AddCourse />} />
            <Route path="/add-leason" element={<AddLeason />} />
            <Route path="/add-module" element={<AddModule />} />
            <Route path="/live-session" element={<LiveSession />} />
            <Route path="/upcoming-session" element={<UpcomingSession />} />
            <Route path="/add-content" element={<AddContent />} />
            <Route
              path="/add-prerecord-lesson"
              element={<AddPrerecordLesson />}
            />
            <Route path="/add-prerecord" element={<AddPrerecord />} />
            {/* <Route path="/inquiry" element={<Inquiry />} /> */}
            <Route path="/setting" element={<Setting />} />
            <Route path="/analytics" element={<Analytics />} />
          </Route>

          {/* Vendor routes */}
          <Route path="/vendor/login" element={<VendorLogin />} />
          <Route path="/vendor/add-mobile" element={<PhoneModal />} />
          <Route
            path="/vendor/otp-verification"
            element={<OTPVerificationModal />}
          />
          <Route
            path="/vendor/forgot-password"
            element={<ForgotPasswordModal />}
          />
          <Route
            path="/vendor/reset-password"
            element={<ResetPasswordModal />}
          />
          <Route element={<VendorRoute />}>
            <Route path="/vendor/" element={<VendorOverview />} />
            <Route path="/vendor/colleges" element={<VendorColleges />} />
            <Route
              path="/vendor/college-list"
              element={<VendorCollegeList />}
            />
            <Route path="/vendor/add-college" element={<VendorAddCollege />} />
            <Route path="/vendor/teachers" element={<VendorTeachers />} />
            <Route
              path="/vendor/teacher-list"
              element={<VendorTeacherList />}
            />
            <Route path="/vendor/courses" element={<VendorCourses />} />
            <Route path="/vendor/add-course" element={<VendorAddCourse />} />
            <Route path="/vendor/add-leason" element={<VendorAddLeason />} />
            <Route path="/vendor/add-module" element={<VendorAddModule />} />
            <Route
              path="/vendor/add-prerecord"
              element={<VendorAddPrerecord />}
            />
            <Route
              path="/vendor/add-prerecord-lesson"
              element={<VendorAddPrerecordLesson />}
            />
            <Route path="/vendor/add-content" element={<VendorAddContent />} />
            <Route
              path="/vendor/live-session"
              element={<VendorLiveSession />}
            />
            <Route
              path="/vendor/upcoming-session"
              element={<VendorUpcomingSession />}
            />
            <Route path="/vendor/students" element={<VendorStudents />} />
            <Route path="/vendor/college" element={<VendorCollege />} />
            <Route
              path="/vendor/teachers-list"
              element={<VendorTeachersList />}
            />
            <Route
              path="/vendor/view-quizzes"
              element={<VendorViewQuizzes />}
            />
            <Route
              path="/vendor/create-details"
              element={<VendorCreateDetails />}
            />
            <Route
              path="/vendor/show-question"
              element={<VendorShowQuestion />}
            />
            <Route
              path="/vendor/evaluate-details"
              element={<VendorEvaluateDetails />}
            />
            <Route
              path="/vendor/student-list"
              element={<VendorStudentList />}
            />
            <Route path="/vendor/add-student" element={<VendorAddStudent />} />
            <Route path="/vendor/add-teacher" element={<VendorAddTeacher />} />
            <Route path="/vendor/approvals" element={<Approvals />} />
            <Route path="/vendor/approval-list" element={<ApprovalList />} />
            <Route path="/vendor/analytics" element={<VendorAnalytics />} />
          </Route>

          {/* Teacher routes */}
          <Route path="/teacher/login" element={<TeacherLogin />} />
          <Route path="/teacher/add-mobile" element={<AddModal />} />
          <Route
            path="/teacher/otp-verification"
            element={<OtpVerification />}
          />
          <Route
            path="/teacher/forgot-password"
            element={<TeacherForgotPasswordModal />}
          />
          <Route
            path="/teacher/reset-password"
            element={<TeacherResetPasswordModal />}
          />
          <Route element={<TeacherRoute />}>
            <Route path="/teacher/" element={<TeacherOverview />} />
            <Route path="/teacher/students" element={<TeacherStudents />} />
            <Route
              path="/teacher/student-list"
              element={<TeacherStudentList />}
            />
            <Route
              path="/teacher/add-student"
              element={<TeacherAddStudent />}
            />
            <Route
              path="/teacher/assign-student"
              element={<TeacherAssignStudent />}
            />
            <Route path="/teacher/analytics" element={<TeacherAnalytics />} />
            <Route path="/teacher/courses" element={<TeacherCourses />} />
            <Route path="/teacher/add-course" element={<TeacherAddCourses />} />
            <Route path="/teacher/add-leason" element={<TeacherAddLesson />} />
            <Route path="/teacher/add-module" element={<TeacherAddModule />} />
            <Route
              path="/teacher/live-session"
              element={<TeacherLiveSession />}
            />
            <Route
              path="/teacher/upcoming-session"
              element={<TeacherUpcomingSession />}
            />
            <Route
              path="/teacher/add-content"
              element={<TeacherAddContent />}
            />
            <Route
              path="/teacher/add-prerecord"
              element={<TeacherAddPrerecord />}
            />
            <Route path="/teacher/quiz" element={<TeacherQuizes />} />
            <Route path="/teacher/add-quiz" element={<TeacherAddQuiz />} />
            <Route
              path="/teacher/add-question"
              element={<TeacherAddQuestion />}
            />
            <Route path="/teacher/edit-quiz" element={<TeacherAddQuiz />} />
            <Route
              path="/teacher/edit-quiz/:id/questions"
              element={<TeacherAddQuestion />}
            />
            <Route
              path="/teacher/start-evaluation/:quizID"
              element={<TeacherStartEvaluation />}
            />
            <Route
              path="/teacher/view-details"
              element={<TeacherViewDetails />}
            />
          </Route>

          {/* College routes */}
          <Route path="/college/login" element={<CollegeLogin />} />
          <Route path="/college/add-mobile" element={<AddMobile />} />
          <Route
            path="/college/otp-verification"
            element={<OtpVerifications />}
          />
          <Route
            path="/college/forgot-password"
            element={<CollegeForgotPasswordModal />}
          />
          <Route
            path="/college/reset-password"
            element={<CollegeResetPasswordModal />}
          />
          <Route element={<CollegeRoute />}>
            <Route path="/college/" element={<CollegeOverview />} />
            <Route path="/college/courses" element={<CollegeCourses />} />
            <Route
              path="/college/live-session"
              element={<CollegeLiveSession />}
            />
            <Route
              path="/college/upcoming-session"
              element={<CollegeUpcomingSession />}
            />
            <Route path="/college/students" element={<CollegeStudents />} />
            <Route
              path="/college/student-list"
              element={<CollegeStudentList />}
            />
            <Route
              path="/college/add-student"
              element={<CollegeAddStudent />}
            />
            <Route path="/college/teachers" element={<CollegeTeachers />} />
            <Route
              path="/college/teacher-list"
              element={<CollegeTeacherList />}
            />
            <Route
              path="/college/add-teacher"
              element={<CollegeAddTeacher />}
            />
            <Route
              path="/college/assign-teacher"
              element={<CollegeAssignTeacher />}
            />
            <Route
              path="/college/teachers-list"
              element={<CollegeTeachersList />}
            />
            <Route
              path="/college/view-quizes"
              element={<CollegeViewQuizzes />}
            />
            <Route
              path="/college/create-detail"
              element={<CollegeCreateDetails />}
            />
            <Route
              path="/college/show-questions"
              element={<CollegeShowQuestion />}
            />
            <Route
              path="/college/evaluate-detail"
              element={<CollegeEvaluateDetails />}
            />
            <Route path="/college/analytics" element={<CollegeAnalytics />} />
          </Route>

          {/* Student routes */}
          <Route path="/student/login" element={<StudentLogin />} />
          <Route path="/student/add-mobile" element={<GetOtp />} />
          <Route
            path="/student/otp-verification"
            element={<VerificationsOTP />}
          />
          <Route
            path="/student/forgot-password"
            element={<StudentForgotPasswordModal />}
          />
          <Route
            path="/student/reset-password"
            element={<StudentResetPasswordModal />}
          />
          <Route element={<StudentRoute />}>
            <Route path="/student/" element={<StudentOverview />} />
            <Route path="/student/courses" element={<StudentCourses />} />
            <Route
              path="/student/course-details/:id"
              element={<StudentCourseDetails />}
            />
            <Route
              path="/student/lesson-completed"
              element={<StudentLessonCompleted />}
            />
            <Route
              path="/student/live-session"
              element={<StudentLiveSession />}
            />
            <Route
              path="/student/upcoming-session"
              element={<StudentUpcomingSession />}
            />
            <Route path="/student/quiz" element={<StudentQuizes />} />
            <Route
              path="/student/start-quiz/:id"
              element={<StudentStartQuiz />}
            />
            <Route
              path="/student/result-pending"
              element={<StudentResultPending />}
            />
            <Route
              path="/student/view-certificate/:courseId"
              element={<StudentViewCertificate />}
            />
            <Route
              path="/student/view-result/:id"
              element={<StudentViewResult />}
            />
          </Route>

          {/* Catch-all redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <AlertProvider>
        <IDsProvider>
          <Router>
            <AppRoutes />
            {/* <Suspense fallback={<LoadingFallback />}>
              <Routes>
               
                <Route path="/login" element={<Login />} />
                <Route path="/add-mobile" element={<SendOtp />} />
                <Route path="/otp-verification" element={<VerifyOtp />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />

   
                <Route element={<AdminRoute />}>
                  <Route path="/" element={<Overview />} />
                  <Route path="/vendors" element={<Vendors />} />
                  <Route path="/add-vendor" element={<AddVendor />} />
                  <Route path="/colleges" element={<Colleges />} />
                  <Route path="/college-list" element={<CollegeList />} />
                  <Route path="/add-college" element={<AddCollege />} />
                  <Route path="/teachers" element={<Teachers />} />
                  <Route path="/teacher-list" element={<TeacherList />} />
                  <Route path="/add-teacher" element={<AddTeacher />} />
                  <Route path="/students" element={<Students />} />
                  <Route path="/student-list" element={<StudentList />} />
                  <Route path="/add-student" element={<AddStudent />} />
                  <Route path="/courses" element={<Courses />} />
                  <Route path="/add-course" element={<AddCourse />} />
                  <Route path="/add-leason" element={<AddLeason />} />
                  <Route path="/add-module" element={<AddModule />} />
                  <Route path="/live-session" element={<LiveSession />} />
                  <Route
                    path="/upcoming-session"
                    element={<UpcomingSession />}
                  />
                  <Route path="/add-content" element={<AddContent />} />
                  <Route
                    path="/add-prerecord-lesson"
                    element={<AddPrerecordLesson />}
                  />
                  <Route path="/add-prerecord" element={<AddPrerecord />} />
                  <Route path="/analytics" element={<Analytics />} />
                </Route>

               
                <Route path="/vendor/login" element={<VendorLogin />} />
                <Route path="/vendor/add-mobile" element={<PhoneModal />} />
                <Route
                  path="/vendor/otp-verification"
                  element={<OTPVerificationModal />}
                />
                <Route
                  path="/vendor/forgot-password"
                  element={<ForgotPasswordModal />}
                />
                <Route
                  path="/vendor/reset-password"
                  element={<ResetPasswordModal />}
                />
                <Route element={<VendorRoute />}>
                  <Route path="/vendor/" element={<VendorOverview />} />
                  <Route path="/vendor/colleges" element={<VendorColleges />} />
                  <Route
                    path="/vendor/college-list"
                    element={<VendorCollegeList />}
                  />
                  <Route
                    path="/vendor/add-college"
                    element={<VendorAddCollege />}
                  />
                  <Route path="/vendor/teachers" element={<VendorTeachers />} />
                  <Route
                    path="/vendor/teacher-list"
                    element={<VendorTeacherList />}
                  />
                  <Route path="/vendor/courses" element={<VendorCourses />} />
                  <Route
                    path="/vendor/add-course"
                    element={<VendorAddCourse />}
                  />
                  <Route
                    path="/vendor/add-leason"
                    element={<VendorAddLeason />}
                  />
                  <Route
                    path="/vendor/add-module"
                    element={<VendorAddModule />}
                  />
                  <Route
                    path="/vendor/add-prerecord"
                    element={<VendorAddPrerecord />}
                  />
                  <Route
                    path="/vendor/add-prerecord-lesson"
                    element={<VendorAddPrerecordLesson />}
                  />
                  <Route
                    path="/vendor/add-content"
                    element={<VendorAddContent />}
                  />
                  <Route
                    path="/vendor/live-session"
                    element={<VendorLiveSession />}
                  />
                  <Route
                    path="/vendor/upcoming-session"
                    element={<VendorUpcomingSession />}
                  />
                  <Route path="/vendor/students" element={<VendorStudents />} />
                  <Route path="/vendor/college" element={<VendorCollege />} />
                  <Route
                    path="/vendor/teachers-list"
                    element={<VendorTeachersList />}
                  />
                  <Route
                    path="/vendor/view-quizzes"
                    element={<VendorViewQuizzes />}
                  />
                  <Route
                    path="/vendor/create-details"
                    element={<VendorCreateDetails />}
                  />
                  <Route
                    path="/vendor/show-question"
                    element={<VendorShowQuestion />}
                  />
                  <Route
                    path="/vendor/evaluate-details"
                    element={<VendorEvaluateDetails />}
                  />
                  <Route
                    path="/vendor/student-list"
                    element={<VendorStudentList />}
                  />
                  <Route
                    path="/vendor/add-student"
                    element={<VendorAddStudent />}
                  />
                  <Route
                    path="/vendor/add-teacher"
                    element={<VendorAddTeacher />}
                  />
                  <Route path="/vendor/approvals" element={<Approvals />} />
                  <Route
                    path="/vendor/approval-list"
                    element={<ApprovalList />}
                  />
                  <Route
                    path="/vendor/analytics"
                    element={<VendorAnalytics />}
                  />
                </Route>

     
                <Route path="/teacher/login" element={<TeacherLogin />} />
                <Route path="/teacher/add-mobile" element={<AddModal />} />
                <Route
                  path="/teacher/otp-verification"
                  element={<OtpVerification />}
                />
                <Route
                  path="/teacher/forgot-password"
                  element={<TeacherForgotPasswordModal />}
                />
                <Route
                  path="/teacher/reset-password"
                  element={<TeacherResetPasswordModal />}
                />
                <Route element={<TeacherRoute />}>
                  <Route path="/teacher/" element={<TeacherOverview />} />
                  <Route
                    path="/teacher/students"
                    element={<TeacherStudents />}
                  />
                  <Route
                    path="/teacher/student-list"
                    element={<TeacherStudentList />}
                  />
                  <Route
                    path="/teacher/add-student"
                    element={<TeacherAddStudent />}
                  />
                  <Route
                    path="/teacher/assign-student"
                    element={<TeacherAssignStudent />}
                  />
                  <Route
                    path="/teacher/analytics"
                    element={<TeacherAnalytics />}
                  />
                  <Route path="/teacher/courses" element={<TeacherCourses />} />
                  <Route
                    path="/teacher/add-course"
                    element={<TeacherAddCourses />}
                  />
                  <Route
                    path="/teacher/add-leason"
                    element={<TeacherAddLesson />}
                  />
                  <Route
                    path="/teacher/add-module"
                    element={<TeacherAddModule />}
                  />
                  <Route
                    path="/teacher/live-session"
                    element={<TeacherLiveSession />}
                  />
                  <Route
                    path="/teacher/upcoming-session"
                    element={<TeacherUpcomingSession />}
                  />
                  <Route
                    path="/teacher/add-content"
                    element={<TeacherAddContent />}
                  />
                  <Route
                    path="/teacher/add-prerecord"
                    element={<TeacherAddPrerecord />}
                  />
                  <Route path="/teacher/quiz" element={<TeacherQuizes />} />
                  <Route
                    path="/teacher/add-quiz"
                    element={<TeacherAddQuiz />}
                  />
                  <Route
                    path="/teacher/add-question"
                    element={<TeacherAddQuestion />}
                  />
                  <Route
                    path="/teacher/edit-quiz"
                    element={<TeacherAddQuiz />}
                  />
                  <Route
                    path="/teacher/edit-quiz/:id/questions"
                    element={<TeacherAddQuestion />}
                  />
                  <Route
                    path="/teacher/start-evaluation/:quizID"
                    element={<TeacherStartEvaluation />}
                  />
                  <Route
                    path="/teacher/view-details"
                    element={<TeacherViewDetails />}
                  />
                </Route>

             
                <Route path="/college/login" element={<CollegeLogin />} />
                <Route path="/college/add-mobile" element={<AddMobile />} />
                <Route
                  path="/college/otp-verification"
                  element={<OtpVerifications />}
                />
                <Route
                  path="/college/forgot-password"
                  element={<CollegeForgotPasswordModal />}
                />
                <Route
                  path="/college/reset-password"
                  element={<CollegeResetPasswordModal />}
                />
                <Route element={<CollegeRoute />}>
                  <Route path="/college/" element={<CollegeOverview />} />
                  <Route path="/college/courses" element={<CollegeCourses />} />
                  <Route
                    path="/college/live-session"
                    element={<CollegeLiveSession />}
                  />
                  <Route
                    path="/college/upcoming-session"
                    element={<CollegeUpcomingSession />}
                  />
                  <Route
                    path="/college/students"
                    element={<CollegeStudents />}
                  />
                  <Route
                    path="/college/student-list"
                    element={<CollegeStudentList />}
                  />
                  <Route
                    path="/college/add-student"
                    element={<CollegeAddStudent />}
                  />
                  <Route
                    path="/college/teachers"
                    element={<CollegeTeachers />}
                  />
                  <Route
                    path="/college/teacher-list"
                    element={<CollegeTeacherList />}
                  />
                  <Route
                    path="/college/add-teacher"
                    element={<CollegeAddTeacher />}
                  />
                  <Route
                    path="/college/assign-teacher"
                    element={<CollegeAssignTeacher />}
                  />
                  <Route
                    path="/college/teachers-list"
                    element={<CollegeTeachersList />}
                  />
                  <Route
                    path="/college/view-quizes"
                    element={<CollegeViewQuizzes />}
                  />
                  <Route
                    path="/college/create-detail"
                    element={<CollegeCreateDetails />}
                  />
                  <Route
                    path="/college/show-questions"
                    element={<CollegeShowQuestion />}
                  />
                  <Route
                    path="/college/evaluate-detail"
                    element={<CollegeEvaluateDetails />}
                  />
                  <Route
                    path="/college/analytics"
                    element={<CollegeAnalytics />}
                  />
                </Route>

             
                <Route path="/student/login" element={<StudentLogin />} />
                <Route path="/student/add-mobile" element={<GetOtp />} />
                <Route
                  path="/student/otp-verification"
                  element={<VerificationsOTP />}
                />
                <Route
                  path="/student/forgot-password"
                  element={<StudentForgotPasswordModal />}
                />
                <Route
                  path="/student/reset-password"
                  element={<StudentResetPasswordModal />}
                />
                <Route element={<StudentRoute />}>
                  <Route path="/student/" element={<StudentOverview />} />
                  <Route path="/student/courses" element={<StudentCourses />} />
                  <Route
                    path="/student/course-details/:id"
                    element={<StudentCourseDetails />}
                  />
                  <Route
                    path="/student/lesson-completed"
                    element={<StudentLessonCompleted />}
                  />
                  <Route
                    path="/student/live-session"
                    element={<StudentLiveSession />}
                  />
                  <Route
                    path="/student/upcoming-session"
                    element={<StudentUpcomingSession />}
                  />
                  <Route path="/student/quiz" element={<StudentQuizes />} />
                  <Route
                    path="/student/start-quiz/:id"
                    element={<StudentStartQuiz />}
                  />
                  <Route
                    path="/student/result-pending"
                    element={<StudentResultPending />}
                  />
                  <Route
                    path="/student/view-certificate/:courseId"
                    element={<StudentViewCertificate />}
                  />
                  <Route
                    path="/student/view-result/:id"
                    element={<StudentViewResult />}
                  />
                </Route>

              
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </Suspense> */}
          </Router>
        </IDsProvider>
      </AlertProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
